var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Widget, WidgetGroup } from '@easyquery/core';
import { browserUtils } from '../utils/browser_utils';
/**
 * The widget responsed for rendering the name of the current query.
 */
var QueryNameWidget = /** @class */ (function (_super) {
    __extends(QueryNameWidget, _super);
    /**
     * The default constructor.
     * @param slot The HTML element where our widget should be placed.
     */
    function QueryNameWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.queryEventCallbackId = null;
        _this.group = WidgetGroup.Query | WidgetGroup.QueryStatus;
        return _this;
    }
    QueryNameWidget.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        this.destroyCore();
        this.attachQueryObserver();
    };
    Object.defineProperty(QueryNameWidget.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-query-name';
        },
        enumerable: true,
        configurable: true
    });
    QueryNameWidget.prototype.getWidgetType = function () {
        return 'queryName';
    };
    /**
     * Refresh widget implementation
     */
    QueryNameWidget.prototype.refreshCore = function () {
        this.render();
    };
    QueryNameWidget.prototype.render = function () {
        this.slot.classList.add("" + this.cssPrefix);
        var mobClass = browserUtils.getMobileCssClass();
        if (mobClass) {
            this.slot.classList.add(mobClass);
        }
        if (!this.nameSlot) {
            this.nameSlot = document.createElement('div');
            this.nameSlot.classList.add(this.cssPrefix + "-text");
            this.nameSlot.classList.add(this.cssPrefix + "-theme");
            this.slot.appendChild(this.nameSlot);
        }
        if (!this.asteriskSlot) {
            this.asteriskSlot = document.createElement('span');
            this.asteriskSlot.innerHTML = "*";
            this.asteriskSlot.classList.add(this.cssPrefix + "-asterisk");
            this.slot.appendChild(this.asteriskSlot);
        }
        if (!this.tooltipSlot) {
            this.tooltipSlot = document.createElement('span');
            this.tooltipSlot.classList.add(this.cssPrefix + "-tooltip");
            this.tooltipSlot.classList.add(this.cssPrefix + "-theme");
            this.slot.appendChild(this.tooltipSlot);
        }
        // Update
        var queryName = this.context.getQuery().getName();
        this.nameSlot.textContent = queryName;
        this.tooltipSlot.textContent = queryName;
        this.asteriskSlot.style.visibility = this.context.getQuery().isModified() ? "visible" : "hidden";
    };
    QueryNameWidget.prototype.clear = function () {
        this.slot.innerHTML = "";
        this.nameSlot = null;
        this.tooltipSlot = null;
        this.asteriskSlot = null;
    };
    QueryNameWidget.prototype.attachQueryObserver = function () {
        var _this = this;
        var query = this.context.getQuery();
        this.queryEventCallbackId = query.addChangedCallback(function (event) {
            _this.refreshCore();
        });
    };
    QueryNameWidget.prototype.detachQueryObserver = function () {
        if (this.queryEventCallbackId) {
            var query = this.context.getQuery();
            query.removeChangedCallback(this.queryEventCallbackId);
        }
    };
    QueryNameWidget.prototype.destroyCore = function () {
        this.clear();
        this.detachQueryObserver();
    };
    return QueryNameWidget;
}(Widget));
export { QueryNameWidget };
//# sourceMappingURL=queryname_widget.js.map